import * as React from 'react';
import * as moment from 'moment';
import { GridMonthProps } from '../../components/grid/month';
import GridDay from '../../components/grid/day';
import GridNextPrevMonthDay from '../../components/grid/next-prev-month-day';
import MonthNavigation from '../../custom/components/month-navigation/month-navigation';

const GridMonthView: React.StatelessComponent<GridMonthProps> = props => {
    const hasEvents = props.monthData.events.allDays.length > 0;
    const daysOfTheWeek = moment.weekdays(true);
    // Below functionality prevents the empty "No performances matcher your filters" state from flashing initially.
    //Check for the initial load attribute
    let initialLoad = document.documentElement.hasAttribute('data-initial-load');
    let preLoaded = document.documentElement.hasAttribute('data-month-preload');
    //if there is no initial load attribute, add it and set it to true. Then add the loader
    if (preLoaded) {
        document.documentElement.removeAttribute("data-calendar-loading");
    }
    else if (!initialLoad) {
        document.documentElement.setAttribute("data-initial-load", "true");
        initialLoad = true;
        document.documentElement.setAttribute("data-calendar-loading", "true");
    }
    //If the document now has the attribute, remove the loader
    else {
        document.documentElement.removeAttribute("data-calendar-loading");
    }
    const access = document.getElementById("calendar-accessiblity-icons");

    function gridWithEvents() {
        return (
            <>
                <div className="ace-cal-grid-weekdays-container">
                    <ul className="ace-cal-grid-weekdays" aria-hidden="true">
                        {
                            daysOfTheWeek.map(day => <li className="ace-cal-grid-weekday" key={day}>{day}</li>)
                        }
                    </ul>
                </div>
                <ul className="ace-cal-grid-days" aria-labelledby={`Month-${props.monthData.monthMoment.format("X")}`}>
                    {
                        props.monthData.events.days.map(day =>
                            props.monthData.monthMoment.month() === day.date.getMonth()
                                ? <GridDay key={day.date.toDateString()} day={day} />
                                : <GridNextPrevMonthDay key={day.date.toDateString()} day={day} />
                        )
                    }
                </ul>
             </>
            );
    }
    function gridWithNoEvents() {
        return (
            <>
                <div className="ace-cal-grid-days-empty" dangerouslySetInnerHTML={{ __html: props.text.emptyMonthMessage }} aria-labelledby={`Month-${props.monthData.monthMoment.format("X")}`}></div>
            </>
        );
    }

    function grid() {
        if (hasEvents) {
            if (access) {
                access.removeAttribute("hidden");
            }
            return gridWithEvents()
        }
        else {
            if (access) {
                access.setAttribute("hidden", "")
            }
            return gridWithNoEvents()
        }
    }

    return (
        <li className="ace-cal-grid-month">
            <section>
                <div className="ace-cal-grid-month-name-container">
                    <h3 className="ace-cal-grid-month-name" id={`Month-${props.monthData.monthMoment.format("X")}`}>{props.monthData.monthMoment.format("MMMM YYYY")}</h3>
                    <MonthNavigation />
                </div>
                { grid() }
            </section>
        </li>
    );
}

export default GridMonthView;